import React from 'react';

const Hero: React.FC = () => {
  return (
    <section style={{
      padding: '140px 0 120px 0',
      position: 'relative',
      overflow: 'hidden',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      background: 'linear-gradient(135deg, #1e3a5f 0%, #2d5a87 50%, #1e3a5f 100%)'
    }}>
      <div style={{ position: 'relative', zIndex: 2, width: '100%', maxWidth: '1400px', margin: '0 auto', padding: '0 40px' }}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '60px', flexWrap: 'wrap' }}>
          {/* Green Headshot */}
          <div className="fade-in-up" style={{ flexShrink: 0 }}>
            <img
              src="/natalie-headshot.jpg"
              alt="Natalie headshot"
              style={{
                width: 'auto',
                height: '70vh',
                maxHeight: '600px',
                objectFit: 'cover',
                objectPosition: 'center top',
                borderRadius: '16px',
                boxShadow: '0 20px 60px rgba(0,0,0,0.4)'
              }}
            />
          </div>

          {/* Text Content */}
          <div className="fade-in-up" style={{ maxWidth: '500px' }}>
            <h2 style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: '3rem', fontWeight: '700', color: 'white', marginBottom: '24px', lineHeight: '1.2' }}>
              A Persona Coach
            </h2>
            <div style={{ marginBottom: '32px' }}>
              <p style={{ fontSize: '1.25rem', color: 'white', marginBottom: '20px', lineHeight: '1.6' }}>
                <strong>20+ years as a professional actor</strong> • <strong>Sales leadership</strong> in B2B &amp; B2C export, on both sides of the table • <strong>Community architect</strong> @grandcentralpetaluma
              </p>
              <p style={{ fontSize: '1.125rem', color: 'rgba(255,255,255,0.95)', marginBottom: '20px', lineHeight: '1.6' }}>
                I help you master the art of <em>seamlessly transitioning</em> between your various roles and personas.
              </p>
              <p style={{ fontSize: '1rem', color: 'rgba(255,255,255,0.9)', lineHeight: '1.6' }}>
                Through performance techniques, mindset strategies, and real-world experience, unlock your potential to present authentically and confidently in any setting.
              </p>
            </div>
            <div className="flex gap-4" style={{ flexWrap: 'wrap' }}>
              <a href="#contact" className="btn" style={{ fontSize: '18px', padding: '16px 32px', backgroundColor: 'white', color: '#1e3a5f', textDecoration: 'none', borderRadius: '8px', display: 'inline-block', fontWeight: '600', boxShadow: '0 4px 12px rgba(0,0,0,0.3)' }}>
                Book Free Consultation
              </a>
              <a href="#services" className="btn" style={{
                backgroundColor: 'transparent',
                color: 'white',
                border: '2px solid white',
                fontSize: '18px',
                padding: '16px 32px',
                textDecoration: 'none',
                borderRadius: '8px',
                display: 'inline-block',
                fontWeight: '600'
              }}>
                View Offerings
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;